import { render, staticRenderFns } from "./ViewportBottom.vue?vue&type=template&id=516881de&scoped=true"
import script from "./ViewportBottom.vue?vue&type=script&lang=js"
export * from "./ViewportBottom.vue?vue&type=script&lang=js"
import style0 from "./ViewportBottom.vue?vue&type=style&index=0&id=516881de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516881de",
  null
  
)

export default component.exports